import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { ODataV4Adaptor, WebApiAdaptor, WebMethodAdaptor, UrlAdaptor } from '@syncfusion/ej2-data';
import { catchError, mergeMap, map } from 'rxjs/operators';
import { HelperService } from './helper.service';
import { MyDataAdaptor, ListDataAdaptor } from '../helpers/grid.adaptor';
import { MyDataManager } from '../helpers/data-manager';

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(private helper: HelperService, private http: HttpClient, @Inject('BASE_URL') public baseUrl: string)
    {
    }

    getUrl() {
        return this.baseUrl;
    }

    private addParams(query: string, auth: any) {
        let queryEx = '';
        if (auth != null) {
            let i = query.indexOf("?");
            if (i == -1)
                queryEx = `${query}?UserName=${auth.LoginUser}&UserType=${auth.LoginType}&PrnCode=${auth.Principal}`;
            else
                queryEx = `${query}&UserName=${auth.LoginUser}&UserType=${auth.LoginType}&PrnCode=${auth.Principal}`;
        }
        else
            queryEx = query;

        return queryEx;
    }

    getByManager(query: string, auth: any) {
        //let queryEx = this.addParams(query, auth);
        //let datManager = new DataManager({ url: this.baseUrl + queryEx, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });

        let datManager = new MyDataManager(this.baseUrl + query, new MyDataAdaptor(this.helper), auth.tokenJWT);
        return datManager;
    }

    getByEditManager(query: string, auth: any) {
        let datManager = new MyDataManager(this.baseUrl + query, new WebApiAdaptor(), auth.tokenJWT);
        return datManager;
    }

    getByListManager(query: string, auth: any) {
        //let queryEx = this.addParams(query, auth);
        //let datManager = new DataManager({ url: this.baseUrl + queryEx, adaptor: new ODataV4Adaptor(), crossDomain: true });

        let datManager = new MyDataManager(this.baseUrl + query, new ODataV4Adaptor(), auth.tokenJWT);
        return datManager;
    }

    get(query: string, succCallback: any, failedCallback: any = null) {
        this.http.get<any>(this.baseUrl + query).subscribe(res => {
            if (res.HasError) {
                this.helper.alertFailed(res.ErrorMessages[0], 'Load data failed');

                if (failedCallback != null)
                    failedCallback(res);
            }
            else
                succCallback(res);
        }, error => {
            console.log(error);
            this.helper.alertFailed('Load data failed');

            if (failedCallback != null)
                failedCallback(error);
        });
    }

    getSilent(query: string, succCallback: any, failedCallback: any = null) {
        this.http.get<any>(this.baseUrl + query).subscribe(res => {
            if (res.HasError) {
                if (failedCallback != null)
                    failedCallback(res);
            }
            else
                succCallback(res);
        }, error => {
            console.log(error);

            if (failedCallback != null)
                failedCallback(error);
        });
    }

    post(query: string, item: any, succCallback: any, failedCallback: any = null) {
        this.http.post<any>(this.baseUrl + query, item).subscribe(res => {
            if (res.HasError) {
                if (failedCallback != null)
                    failedCallback(res);
                else
                    this.helper.alertFailed(res.ErrorMessages[0], 'Action failed');
            }
            else {
                succCallback(res);
            }
        }, error => {
            if (failedCallback != null)
                //failedCallback(error);
                failedCallback(null);
            else {
                console.log(error);
                this.helper.alertFailed('Action failed');
            }
        });
    }


    postManual(query: string, item: any, succCallback: any, failedCallback: any = null) {
        this.http.post<any>(this.baseUrl + query, item).subscribe(res => {
            succCallback(res);
        }, error => {
            if (failedCallback != null)
                //failedCallback(error);
                failedCallback(null);
            else {
                console.log(error);
                this.helper.alertFailed('Action failed');
            }
        });
    }





    save(query: string, item: any, succCallback: any, failedCallback: any = null) {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
        let options = { headers: headers };
        let dat = JSON.stringify(item);

        this.http.post<any>(this.baseUrl + query, dat, options).subscribe(res => {
            if (res.HasError) {
                if (failedCallback != null)
                    failedCallback(res);
                else
                    this.helper.alertFailed('Save failed');
            }
            else {
                this.helper.alert('Save success');
                succCallback(res);
            }
        }, error => {
            console.log(error);
            this.helper.alertFailed('Save failed');
        });
    }

    saveSilent(query: string, item: any, succCallback: any, failedCallback: any = null) {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
        let options = { headers: headers };
        let dat = JSON.stringify(item);

        this.http.post<any>(this.baseUrl + query, dat, options).subscribe(res => {
            if (res.HasError) {
                if (failedCallback != null)
                    failedCallback(res);
                else
                    this.helper.alertFailed('Save failed');
            }
            else {
                //this.helper.alert('Save success');
                succCallback(res);
            }
        }, error => {
            console.log(error);
            this.helper.alertFailed('Save failed');
        });
    }

    delete(query: string, succCallback: any, failedCallback: any = null) {
        this.http.delete<any>(this.baseUrl + query).subscribe(res => {
            if (res.HasError) {
                if (failedCallback != null)
                    failedCallback(res);
                else
                    this.helper.alertFailed('Delete failed');
            }
            else {
                this.helper.alert('Delete success');
                succCallback(res);
            }
        }, error => {
            console.log(error);
            this.helper.alertFailed('Delete failed');
        });
    }



    download(query: string, succCallback: any, failedCallback: any = null) {
        this.http.get(this.baseUrl + query, { responseType: 'blob' }).subscribe(res => {
            succCallback(res);

        }, error => {
            console.log(error);
            this.helper.alertFailed('Download failed');
        });
    }

    downloadEx(query: string, items: any, succCallback: any, failedCallback: any = null) {
        let params = new HttpParams()

        items.forEach(p => {
            let keys = Object.getOwnPropertyNames(p);
            let key = keys[0];

            if (p[key] != null)
                params.append(key, '' + p[key]);
        });

        this.http.get(this.baseUrl + query, { responseType: 'blob', params: params }).subscribe(res => {
            succCallback(res);

        }, error => {
            console.log(error);
            this.helper.alertFailed('Download failed');
        });
    }

    downloadSelections(query: string, items: any, succCallback: any, failedCallback: any = null) {

        this.http.post(this.baseUrl + query, items, { responseType: 'blob' }).subscribe(res => {
            succCallback(res);

        }, error => {
            console.log(error);
            this.helper.alertFailed('Download failed');
        });
    }

    pipe(query: string, dat: any) {
        return this.http.post<any>(this.baseUrl + query, dat).pipe(
            map(res => {
                return res;
            })
        );
    }
}
